module.exports = __webpack_public_path__ + "img/@temp_gate01_1200_800.6bfd1d8c.jpg";